import React, { useState, useEffect, createContext, useContext, useRef} from 'react';
import gsap from 'gsap';
import Product from './product';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar } from 'swiper/modules';
import '../styles/layout/product-catalog.scss';

import placeholder_img from '../images/placeholder-image.png';
import magGlass from '../icons/magnifying-glass.svg';
import arrow from '/src/icons/arrow.svg';

// TODO
// Handle pagination for the Items when they are categories; right now only product items can paginate

const root = document.querySelector('#render-react-product_category');
const backgroundSearch = root ? root.getAttribute('hero-image-search') : '/wp-content/uploads/2023/09/kelly-sikkema-ettyLtH2GjU-unsplash-e1696012100998.jpg';
const backgroundProduct = root ? root.getAttribute('hero-image-product') : '/wp-content/uploads/2023/09/products_background1.jpg';

const ProductCategories = () => {
  const wrapperRef = useRef(null);
  const productRef = useRef(null);
  const [categories, setCategories] = useState([]);
  const [activeCats, setActiveCats] = useState([]);
  const [items,setItems] = useState([]);

  const search_options = [
    {id: 'product', name:'Product'},
    {id: 'category', name:'Category'},
  ];
  const [active_product, setActiveProduct] = useState(null);
  
  useEffect(()=>{
    const fetchCats = () => {
      // axios.get(`/wp-json/wp/v2/product_category?hide_empty=true&per_page=100`)
      axios.get(`/wp-json/wp/v2/product_category?per_page=100`)
        .then((res) => {
          //console.log('categories',res.data);
          setCategories(res.data);
        })
        .catch((err) => console.error('fetchCats()',err));

    }
    const fetchFeatProducts = async (slug) => {
      try {
        const feat_term = await getFeaturedCategoryFromSlug(slug);
        const response = await fetch(
          `/wp-json/wp/v2/product?featured-category=${feat_term?.id}&_embed`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setActiveCats([feat_term]);
        console.log("SETTING ITEMS",data,[feat_term] );
        // setItems(data);
      } catch (error) {
        console.error('Error fetching featured products:', error);
      }
    };
    const searchParams = new URLSearchParams(window.location.search);
    const featuredSlug = searchParams.get('featured');
    if (featuredSlug) {
      fetchFeatProducts(featuredSlug);
    } else {
      fetchCats();
    }

  }, []);
  
  useEffect(() => {
    const readURLParams = () => {
      //console.log("Reading URLS!")
      const urlSearchParams = new URLSearchParams(window.location.search);
      if(urlSearchParams.get('type') ){
        const url_cats = translateSlug(urlSearchParams.get('type'),categories);
        //console.log('url_cats',url_cats);
        setActiveCats(url_cats);
      }
      
    };
    readURLParams();
    window.addEventListener('popstate', readURLParams);
    return () => {
      window.removeEventListener('popstate', readURLParams);
    };
  }, [categories])

  useEffect(() => {
    if(activeCats.length > 0 && categories.length > 0){
      updateUrlParams('type',activeCats.map(cats => cats.slug));
    }
  }, [activeCats])

  useEffect(()=>{
    const updateMinHeight = () => {
      //console.log('updateMinHeight');
      if (productRef.current) {
          const newHeight = productRef.current.offsetHeight;
          wrapperRef.current.style.minHeight = newHeight+'px';
        }
      };
      
    const observer = new ResizeObserver(updateMinHeight);
      
    
    //console.log('activepro',active_product,typeof active_product);
    if(active_product != null && productRef.current){
      window.history.replaceState({}, '', active_product.link);
      observer.observe(productRef.current);
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
    if(active_product === null && activeCats.length > 0 && categories.length > 0) {
      window.history.replaceState({}, '', '/products');
      updateUrlParams('type',activeCats.map(cats => cats.slug));
    }

    // Clean up the observer when the component unmounts
    return () => {
        if (productRef.current) {
          observer.unobserve(productRef.current);
        }
    };

  },[active_product])

  //console.log('items',items,'activeCats',activeCats,'categories',categories);
  return(
    <div ref={wrapperRef} className={(active_product != null) ? "products__wrapper products__wrapper--product" : "products__wrapper products__wrapper--catalog"}>
      <header 
        className="products__hero-wrapper" 
        style={{ backgroundImage: activeCats.length == 0 ? `url(${backgroundSearch})` : `url(${backgroundProduct})` }}
      >
        <HeroContent activeCats={activeCats} categories={categories} />
        <Search setItems={setItems} search_options={search_options} categories={categories}/>
      </header>
      <TermSelection activeCats={activeCats} setActiveCats={setActiveCats} categories={categories}/>
      <TermCopy activeCats={activeCats} categories={categories}/>
      <ItemList items={items} setItems={setItems} activeCats={activeCats} setActiveCats={setActiveCats} setActiveProduct={setActiveProduct} categories={categories}/>
      <div ref={productRef} className={active_product ? "products__product-wrapper products__product-wrapper--active" : "products__product-wrapper"}>
        <div>
          <Product inCatalog={true} product={active_product} setActiveProduct={setActiveProduct}/>
        </div>
      </div>
    </div>
  )
}

function updateUrlParams (param, values) {
  const url = new URL(window.location.href);
  if (values !== null && typeof values === "object") {
    console.log("delete param",param);
    url.searchParams.set(param, values.join(','));
  } else if (values !== null && typeof values === "string") {
    console.log("add param",param);
    url.searchParams.set(param, values);
  } else {
    console.log("delete param",param);
    url.searchParams.delete(param);
  }
  window.history.replaceState({}, '', url);
};

function findLowestTerm(activeCats){
  return activeCats.find(
    (term) => !activeCats.some((other) => other.parent === term.id)
  );
}

function findParentTerms(categories, termId) {
  const parents = [];
  let term = categories.find(t => t.id === termId);
  while (term && term.parent) {
    const parent = categories.find(t => t.id === term.parent);
    if (!parent) break;
    parents.push(parent);
    term = parent;
  }
  return parents;
}

// Given term slug, returns term object
function translateSlug(url_slugs, cats){
  //console.log('translateSlug',url_slugs);
  const slugs = url_slugs.split(",");
  const terms = [];
  slugs.forEach(slug =>{
    const matchingTerm = cats.find(term => term.slug === slug);
    //console.log(slug, matchingTerm);
    if(matchingTerm){
      terms.push(matchingTerm);
    }
  });
  return terms;
}

const HeroContent = ({activeCats, categories}) => {
  const imageRef = useRef(null);
  const textRef = useRef(null);
  const [activeTerm, setActiveTerm] = useState(undefined);
  const [suptitle, setSuptitle] = useState('');

  useEffect(() =>{
    //console.log('useEffect activeCats',activeCats );
    if(activeCats.length == 0){
      setActiveTerm(undefined);
    }

    if (activeCats.length > 1) {
      const lowestTerm = findLowestTerm(activeCats);
      setActiveTerm(lowestTerm);
      if(lowestTerm.parent === 0){
        setSuptitle('Category');
      } else {
        const cat_name = activeCats.find(term => term.id === lowestTerm.parent).name
        setSuptitle(cat_name);
      }
      //console.log('my log!', lowestTerm, suptitle, activeCats);
    } else {
      setActiveTerm(activeCats[0]);
      setSuptitle('Products');
    }
  },[activeCats])
  
  useEffect(() => {
    if(imageRef.current && textRef.current && activeTerm){
      //console.log("play");
      gsap.fromTo(imageRef.current, {
        x:100,
        opacity:0,
      },{
        duration: 0.5,
        x:0,
        opacity:1,
      });
      gsap.fromTo(textRef.current, {
        x:-100,
        opacity:0,
      },{
        duration: 0.5,
        x:0,
        opacity:1,
      });
    }
  },[activeTerm])

  if(activeTerm === undefined){
    return ( 
      <div className='text' >
        {/* <h1>Products</h1> */}
        <h2 >Products</h2>
      </div> 
    )
  }
  
  return (
    <>
      <div className='image' ref={imageRef}>
        <img 
          key={activeTerm.id}
          className="term-logo" 
          src={(activeTerm.acf.large_logo) ? activeTerm.acf.large_logo : (activeTerm.acf.logo ? activeTerm.acf.logo : '#')} 
          />
      </div>
      <div className='text' >
        <h1>{suptitle}</h1>
        <h2 
          ref={textRef}
          dangerouslySetInnerHTML={{ __html: activeTerm.name}}
          key={activeTerm.id}
          style={{animation: 'moveFromLeft 800ms ease-out forwards' }} 
          ></h2>
      </div>
    </>
  )
}

const Search = ({setItems, search_options, categories}) => {
  const inputRef = useRef(null);
  const [text,setText] = useState('');
  const [selected_option, setSearchOption] = useState(search_options[0].id);
  const [searchState, setSearchState] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if(text){
      setSearchState(true);
    } else {
      setSearchState(false);
    }
  }

  useEffect(() => {
    if (searchState && text && selected_option) {
      // window.history.replaceState({}, '', `?search=${text}&option=${selected_option}`);
      updateUrlParams('search',text);
      updateUrlParams('option',selected_option);
      updateUrlParams('type');
      setItems([]);
    }
  }, [searchState]);

  useEffect(()=>{
    setSearchState(false);
  }, [text]);


  const handleClear = () =>{
    if(searchState){
      setText('');
    }
  }

  if(categories.length == 0){
    return null
  }
  
  return(
    <form className="recipe-catalog__search" name='recipe-search' onSubmit={(e) => handleSubmit(e)}>
        <label HTMLfor="recipe-search">Find the product you're looking for</label>
        <div className="input-wrapper">
          <select onChange={(e) => setSearchOption(e.target.value)}>
            {search_options.map((option,index) => 
                (
                <option key={index} value={option.id}>{option.name}</option>
                )
            )}
          </select>
          <input
              name="query"
              type="text"
              placeholder="Search..." 
              ref={inputRef}
              onClick={() => {
                //this.select();
              }}
              onChange={(e) => {
                setText(e.target.value);
              }}
          />
          <button 
            onClick={() => {handleClear()}}
            type='reset' 
            className={(text) ? 'close' : 'close close--hide'}
          >
              Clear form
          </button>
          <button type='submit' className='submit'>
              <img src={magGlass} />
          </button>
        </div>
    </form>
  )
}

const TermSelection = ({activeCats,setActiveCats,categories}) => {
  const listRef = useRef(null);
  const [terms,setTerms] = useState([]);
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' && window.innerWidth < 768);

  const findMaxWidth = () => {
      let maxWidth = 0;
      const liElements = listRef.current.children;
      for (let i = 0; i < liElements.length; i++) {
          const liWidth = liElements[i].scrollWidth;
          maxWidth = Math.max(maxWidth, liWidth);
      }
      return maxWidth+10;
  };

  const setEqualWidth = () => {
      const screenWidth = window.scrollWidth;
      if (screenWidth < 1000) {
          const maxWidth = findMaxWidth();
          const liElements = listRef.current.children;
          for (let i = 0; i < liElements.length; i++) {
              liElements[i].style.width = `${maxWidth}px`;
          }
      }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);

    if(terms.length !== 0){
      setEqualWidth();
      window.addEventListener("resize", setEqualWidth);
    }

    return () => {
        window.removeEventListener("resize", setEqualWidth);
    };
  }, [terms]);

  useEffect(() => {
    //console.log('useEffect(activeCats)',activeCats);
    if(activeCats.length > 0){
      const lowestTerm = findLowestTerm(activeCats);
      //console.log('TermSelection lowestTerm', lowestTerm)
      let temp_terms = categories.filter((term) => term.parent === lowestTerm.parent);
      // if(temp_terms.length == 0){
      //   //No sub categories;
      //   temp_terms = categories.filter((term) => term.parent === lowestTerm.parent);
      // }
      //console.log("TermSelection setTerms", temp_terms);
      setTerms(temp_terms);
    }
  },[activeCats])


  const handleCatClick = (term) =>{
    //console.log('handleCatClick',term);
    const lowestTerm = findLowestTerm(activeCats);
    //console.log(lowestTerm);
    if(term == -1){
      setActiveCats((prevActiveCats) => 
        prevActiveCats.filter((term => term.id !== lowestTerm.id)
      ));
      return
    } 

    //console.log(term.parent,lowestTerm.parent,term.parent <= lowestTerm.parent);
    if(term.parent == lowestTerm.parent){
      setActiveCats((prevActiveCats) => [
        ...prevActiveCats.filter((t) => t.id !== lowestTerm.id), // Remove lowestTerm
        term, // Add the new term
      ]);
    } else {
      setActiveCats((prevActiveCats) => [
        ...prevActiveCats,
        term, // Add the new term
      ]);
    }
    
  }

  if(terms.length === 0 ){
    return( 
      <nav className="products__nav" aria-description='Product Category Navigation Bar'></nav>
     );
  }

  return (
    <nav className="products__nav" aria-description='Product Category Navigation Bar'>
        {terms[0].parent == 0
          ? null
          : <button
          onClick={() => handleCatClick(-1)}
          className="back-arrow"
          ></button>
        }

      {!isMobile && (
        <ul id="terms" aria-label='List of Product Categories' ref={listRef}>
          {terms.map((term) => (
            <li role='button' 
            onClick={() => handleCatClick(term)} 
            key={term.id} 
            // data-slide={index}
            // data-term-id={term.id}
            // data-term-slug={term.slug}
            dangerouslySetInnerHTML={{__html:term.name}}
            className={activeCats.find(s_term => term.id === s_term.id) ? 'active' : ''}
            ></li>
          ))} 
        </ul>
      )}
      {isMobile && (
          <Swiper
            ref={listRef}
            spaceBetween={10}
            slidesPerView={'auto'}
            scrollbar={{
              hide: true,
            }}
            modules={[Scrollbar]}
            loop={false}
            centeredSlides={false}
            slideToClickedSlide={true}
          >
            {terms.map((term) => (
              <SwiperSlide 
                key={term.id} 
                style={{ width: 'auto' }}
                className={activeCats.find(s_term => term.id === s_term.id) ? 'active' : ''}
              >
                <div
                  role="button"
                  onClick={() => handleCatClick(term)}
                  // data-slide={index}
                  // data-term-id={term.id}
                  // data-term-slug={term.slug}
                  dangerouslySetInnerHTML={{ __html: term.name }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        )}

    </nav>
  )
}

const TermCopy = ({activeCats, categories}) => {
  //When active_cat changes, change the copy
  const [blurb, setBlurb] = useState(null);
  const blurbRef = useRef(null);

  useEffect(() => {
    let temp_blurb;
    // console.log('blurb',blurb);
    // console.log('activeCats',activeCats, findLowestTerm(activeCats));
    if(activeCats){
      const lowestTerm = findLowestTerm(activeCats);
      temp_blurb = (lowestTerm) ? lowestTerm.acf.product_page_blurb : null;
      gsap.to(blurbRef.current,
        { 
          y: '-110%', 
          clipPath: 'inset(100% 0% 0% 0%)',
          duration:0.25,
          onComplete: () =>{
            if(temp_blurb?.title || temp_blurb?.copy || temp_blurb?.image){
              setBlurb(temp_blurb);
              gsap.to(blurbRef.current,
                { 
                  y:'0%', 
                  clipPath: 'inset(0% 0% 0% 0%)',
                  duration:0.5,
                  ease:'power1.out'
                }
              );
      
            } else {
              setBlurb(null);
            }
          }
        }
      );
    }
  },[activeCats])


  return (
    <div ref={blurbRef} className='products__term-copy'>
      { blurb && (
        <>
          <h3>{blurb.title}</h3>
          <div className="text">{blurb.copy}</div>
          <div className="image" style={{ backgroundImage : (blurb.image) ? `url(${blurb.image})` : null }}></div>
        </>
        )
      }
    </div>
  )
}

const ItemList = ({activeCats, setActiveCats, setActiveProduct, categories, items, setItems}) => {
  const listRef = useRef(null);
  const [heading, setHeading] = useState('');
  const [page_num, setPageNum] = useState(1);
  const [total_page_num, setTotalPageNum] = useState(1);
  const per_page = 10;


  const fetchFeaturedProds = async (term, page = 1) => {
    // console.log('term_id',term_id);
    // console.log('page',page);
    const term_id = term.id;
    if(page){
      setPageNum(page);
    } else {
      page = 1;
    }
    const feat_per_page = (term.count / 5).toFixed(0);
    console.log(`/wp-json/wp/v2/product?_embed=true&per_page=${feat_per_page}&featured-category=${term_id}&page=${page}`);
    axios.get(`/wp-json/wp/v2/product?_embed=true&per_page=${feat_per_page}&featured-category=${term_id}&page=${page}`)
      .then((res) => {
        if(res.headers['x-wp-totalpages'] > 1){
          //console.log("res.headers['x-wp-totalpages']",res.headers['x-wp-totalpages']);
          setTotalPageNum(parseInt(res.headers['x-wp-totalpages']));
        }
        // setHeading(res.data[0].taxonomy_info.product_category[1].label);
        //console.log("SETTING ITEMS");
        setItems(res.data);
        listRef.current.classList.remove('products__list-wrapper--loading');
      })
      .catch((e)=>{
        //console.log('Error', e)
      })
  }

  const fetchProducts = async (term_id, page = 1) => {
    // console.log('term_id',term_id);
    // console.log('page',page);
    if(page){
      setPageNum(page);
    } else {
      page = 1;
    }
    axios.get(`/wp-json/wp/v2/product?_embed=true&per_page=${per_page}&product_category=${term_id}&page=${page}`)
      .then((res) => {
        if(res.headers['x-wp-totalpages'] > 1){
          //console.log("res.headers['x-wp-totalpages']",res.headers['x-wp-totalpages']);
          setTotalPageNum(parseInt(res.headers['x-wp-totalpages']));
        }
        // setHeading(res.data[0].taxonomy_info.product_category[1].label);
        //console.log("SETTING ITEMS");
        setItems(res.data);
        listRef.current.classList.remove('products__list-wrapper--loading');
      })
      .catch((e)=>{
        //console.log('Error', e)
      })
  }

  useEffect(()=>{
    //console.log("useEffect[categories,activeCats]",categories,activeCats);
    setTotalPageNum(1);

    if(listRef.current){
      listRef.current.classList.add('products__list-wrapper--loading');
    }

    if(activeCats.length == 0 && categories.length > 0){
      //console.log('setItems', categories.filter(cat => cat.parent == 0));
      //console.log("SETTING ITEMS");
      setItems(categories.filter(cat => cat.parent == 0));
      return
    } 

    const lowestTerm = findLowestTerm(activeCats);
    const subCatsExist = categories.filter(cat => cat.parent == lowestTerm.id);
    //console.log("subCatsExist",subCatsExist);
    setHeading('');
    if(subCatsExist.length != 0){
      //Show more cats
      setTotalPageNum(Math.ceil(subCatsExist.length / per_page));
      //console.log("SETTING ITEMS");
      setItems(subCatsExist);
      listRef.current.classList.remove('products__list-wrapper--loading');
    } else if(lowestTerm && categories.length > 0) {
      //Show products
      fetchProducts(lowestTerm.id);
    } else {
      //might be featured
      if(lowestTerm){
        fetchFeaturedProds(lowestTerm);
      }
      // fetchProducts(lowestTerm.id);
      if(listRef.current){
        listRef.current.classList.remove('products__list-wrapper--loading');
      }
    }

  }, [categories,activeCats]);

  const handleClick = (e,type,item) => {
    e.preventDefault();  
    console.log('activeCats',activeCats);
    const queryParams = new URLSearchParams(window.location.search);
    const isSearch = queryParams.get('search') ? true : false;
    if(type == 'category' && isSearch){
      updateUrlParams('search');
      updateUrlParams('option');
      updateUrlParams('type');
      const parent_terms = findParentTerms(categories, item.id);
      console.log('setting...',parent_terms);
      setActiveCats( [...parent_terms, item]);
    } else if (type == 'category'){
      setActiveCats((prevActiveCats) => [
        ...prevActiveCats,
        item, 
      ]);
    } else{
      setActiveProduct(item);
    }
  }
  const handlePagination = (page) => {
    console.log("handlePagination", categories.length);
    let num = (page === 0) ? 1 : page;
    num = (num > total_page_num) ? num - 1 : num;
    const lowestTerm = findLowestTerm(activeCats);

    const queryParams = new URLSearchParams(window.location.search);
    const text = queryParams.get('search');
    const selected_option = queryParams.get('option');
    if(text && selected_option){
      //search case
      restSearch(text,selected_option, page);
    } else if(categories.length > 0){
      // default case
      fetchProducts(lowestTerm.id,page);
    } else{
      //featured case
      fetchFeaturedProds(lowestTerm, page);
    }
  }

  useEffect(() => {
    //console.log("useEffect[items]",items);
    const queryParams = new URLSearchParams(window.location.search);
    const text = queryParams.get('search');
    const selected_option = queryParams.get('option');
    //console.log("useEffect 603",items.length,text, selected_option)
    if(items.length == 0 && text && selected_option){
      //Cleared by search, look for search params
      //console.log('detected search');
      setHeading(`Search results for '${text}'`);
      restSearch(text,selected_option);
    }
  }, [items]);

  const restSearch = async (text,selected_option, page = 1) => {
    if(page){
      setPageNum(page);
    } else {
      page = 1;
    }
    const encodedQuery = encodeURIComponent(text);
    //console.log('selected_option',selected_option,encodedQuery);
    let url;
    const per_page = 12;
    const rest_safe_option = (selected_option == 'category') ? 'product_category' : selected_option;
    url = `/wp-json/custom/v1/search?search=${encodedQuery}&type=${rest_safe_option}&per_page=${per_page}&_embed&page=${page}`;
    console.log(url);
    //Returns combined ids from keyword and generic text search
    axios.get(url)
      .then((res) => {
          console.log("res",res);
          // Handle the response here
          //console.log("SETTING ITEMS");
          if(res.data.length > 0){
            setTotalPageNum(parseInt(res.headers['x-wp-totalpages']));
            setItems(res.data);
            if(listRef.current){
              listRef.current.classList.remove('products__list-wrapper--loading');
            }
          } else {
            setHeading(`No results for '${text}'`);
          }
        })
        .catch((err) => {
            console.log("Error in search",err);
        });
    //console.log(url);
  }

  useEffect(() => {
    if(listRef.current){
      listRef.current.classList.add('products__list-wrapper--loading');
    }
  }, [page_num]);

  const clearSearch = () =>{
    window.history.replaceState({}, '', '/products');
    setHeading('');
    //console.log('clearSearch');
    if(activeCats.length > 0){
      updateUrlParams('type',activeCats.map(cats => cats.slug));
      updateUrlParams('search');
      updateUrlParams('option');
    } else {
      //console.log("SETTING ITEMS");
      setItems(categories.filter(cat => cat.parent == 0));
    }
  }
  
  if(items.length === 0){
    return (
      <div className={(heading) ? "products__list-wrapper products" : "products__list-wrapper products__list-wrapper--loading"}>
        <h2 className={(heading) ? '' : 'hide'}>
            {heading}
            <button 
              onClick={() => {clearSearch()}}
              type='reset' 
              className={(heading) ? 'close' : 'close--hide'}
            > Clear form
            </button>
          </h2>
      </div>
    );
  }
  //console.log('total_page_num:',total_page_num);
  console.log('items',items);
  return (
    <div className="products__list-wrapper" ref={listRef}>
        <h2 className={(heading) ? '' : 'hide'}>
          {heading}
          <button 
            onClick={() => {clearSearch()}}
            type='reset' 
            className={(heading) ? 'close' : 'close--hide'}
          > Clear form
          </button>
        </h2>
        {items.map((item)=> {
          console.log('item',item);
          const type = (item?.count != undefined) ? 'category' : 'product';
          let image;
          let caption;
          if(type == 'category'){
            image = item.acf?.logo ?? placeholder_img;
            caption = `<p class="title">${item.name}</p>`;
          } else{
            //console.log('product',item);
            image = item?.featured_image_src ? item?.featured_image_src[0] : placeholder_img;
            caption = `
              <p class="suptitle">${item.acf?.product_size}</p>
              <p class="title">${item.title.rendered}</p>
              `;
          }
          return (
              <a className="item__wrapper"
                aria-label={"View "+type}
                onClick={(e) => handleClick(e,type,item)}
                href={(type === 'product') ?? item.link }
              >
                <div className="img-wrapper">
                  <img 
                    src={image}
                    alt='logo'/>
                </div>
                  <div 
                    className="caption"
                    dangerouslySetInnerHTML={{ __html:caption}}
                  ></div>
              </a>
          )
        })}
      <div className={total_page_num === 1 ? "pagination pagination--hide":"pagination"}>
          <button className="prev" onClick={()=>handlePagination(page_num - 1)}><img src={arrow} /></button>
          {[...Array(total_page_num)].map((_, index) => (
              <button className={(page_num === index+1) ? "page page--active" : "page" } key={index} onClick={() => handlePagination(index + 1)}>{index + 1}</button>
          ))}
          <button className="next" onClick={()=>handlePagination(page_num + 1)}><img src={arrow} /></button>
      </div>
    </div>
  )
}

const getFeaturedCategoryFromSlug= async (slug) => {
  const taxonomy = "featured-category";
  const apiUrl = `/wp-json/wp/v2/${taxonomy}?slug=${slug}`; // REST API endpoint

  try {
      const response = await fetch(apiUrl);
      if (!response.ok) {
          throw new Error(`Error fetching terms: ${response.status}`);
      }
      const data = await response.json();
      //console.log(data);
      if (data.length > 0) {
          return data[0];
      } else {
          throw new Error(`No term found with slug "${slug}"`);
      }
  } catch (error) {
      console.error("Error fetching recipe category term ID:", error);
      return null; // Return null in case of error
  }
};


export default ProductCategories

